import { Link } from 'react-router-dom';
import { EXPLORE_PLACES } from '../utils/homeData.js';
import { withBasePath } from '../utils/paths.js';

export default function ExploreMauritania() {
  return (
    <section className="py-16 sm:py-20" id="explore">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="v4-reveal mb-10 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-nkc-gold">Explore Mauritania</p>
            <h2 className="mt-2 font-display text-3xl font-bold text-nkc-navy sm:text-4xl">
              Where desert, ocean, and heritage meet
            </h2>
          </div>
          <Link to="/attractions" className="text-sm font-bold text-nkc-blue hover:underline">
            All attractions →
          </Link>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {EXPLORE_PLACES.map((p) => (
            <Link
              key={p.title}
              to={p.to}
              className="v4-reveal v4-zoom group relative overflow-hidden rounded-3xl shadow-soft ring-1 ring-nkc-blue/10"
            >
              <img
                src={withBasePath(p.image)}
                alt={p.title}
                className="aspect-[5/4] w-full object-cover"
                loading="lazy"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-nkc-navy/80 via-transparent to-transparent" />
              <span className="absolute bottom-0 p-5 font-display text-xl font-bold text-white">{p.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
